import { AssetAbridged } from "../abridged/asset-abridged.model";
import { SiteAbridged } from "../abridged/site-abridged.model";
import { UserAbridged } from "../abridged/user-abridged.model";
import { WorkOrderAbridged } from "../abridged/work-order-abridged.model";
import { SiteForm } from "./site-form.model";

export class SiteFormResponse {
  id: number;
  user: UserAbridged;
  createdDate: Date;
  answers: { [index: number]: string|string[] };
  form: SiteForm
  submittedBy: string;

  // connecitons
  site: SiteAbridged;
  asset: AssetAbridged;
  workOrder: WorkOrderAbridged;

  attachments: string[] = [];

  public deserialize(input: any): this {
    this.id = input.id;
    this.createdDate = new Date(input.createdDate);
    this.answers = JSON.parse(input.formResponseData);
    this.form = new SiteForm().deserialize(input.siteForm);
    this.submittedBy = input.submittedBy;

    this.user = new UserAbridged().deserialize(input.workerUser);

    if (input.userSession && input.userSession.siteSession) {
      this.site = new SiteAbridged().deserialize(input.userSession.siteSession.site);

      if (input.userSession && input.userSession.siteSession.workOrder) {
        this.workOrder = new WorkOrderAbridged().deserialize(input.userSession.siteSession.workOrder);
        this.asset = new AssetAbridged().deserialize(input.userSession.siteSession.workOrder.asset);
      }
    } else if (input.site) {
      this.site = new SiteAbridged().deserialize(input.site);
    }

    return this;
  }

  // return one string answer for simple inputs whether they have one answer or multiple needing joined together.
  public getAnswer(i) : string {
    if (!this.answers[i]) {
      return '';
    } else if (typeof this.answers[i] === 'string') {
      return this.answers[i] as string;
    } else {
      return (this.answers[i] as string[]).join(', ');
    }
  }

  public getAnswerArray(i) : string[] {
    return (this.answers[i] as string[]);
  }

  public isSiteSession() {
    return !this.workOrder;
  }
};
